import {
    horzRecSlick
} from './_horzRecSlick';
import {
    vertAddToBagRecSlick
} from './_vertAddToBagRecSlick';
import {
    desktopTabletVerticalRecs
} from '../carousel/_verticalRecs';
import {
    isInternational
} from '../global/_checkForInternational';
import {
  addToBagResize
} from '../global/_addToBagResize';
import {
    pageSetup
} from '../carousel/_pageSetup';
import {
    zonePopulation
} from './_zonePopulation';
import {
    disableSlickArrow
} from '../carousel/_disableSlickArrow';
import { lazyloadObserver } from '../global/_lazyloadObserver';


const buildRecs = (zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, pageType) => {
    var lines = zonePopulation(zone, rec_attributes);
    if (lines && lines.length > 0) {
        recHead.html(target_header_txt);
        recList.html(lines.join("\n"));
        switch (pageType) {
            case 'SCPZ2':    
            case 'PDPZ1':
            case 'PDPZ3':
            case 'SCPZ1':
                if(($('.desktopPage').length > 0) || (($('.tabletPage').length > 0) && window.innerWidth > window.innerHeight)){
                    if(($('#shopping-bag tr').length - 1) == 3){
                        $('#rec-list-contain').css('cssText', 'height:1095px !important;')
                    }else if(($('#shopping-bag tr').length - 1) == 4){
                        $('#rec-list-contain').css('cssText', 'height:1310px !important;')
                    }else if(($('#shopping-bag tr').length - 1) >= 5){
                        $('#rec-list-contain').css('cssText', 'height:1525px !important;')
                    }
                }
                if (($('#vert-rec .rec-list li').length > 0) && !Modernizr.mq('(max-width: 991px)')) {
                    ($('#layoutProduct').length > 0) ? $('#content-wrapper').css('min-height', '1200px'): $('#content-wrapper').css('min-height', '690px');
                }
                break;
            case 'PDPZ2':
                if ($('#content-wrapper').hasClass('container nav-four-product')) $('.recently-viewed-results').removeClass('col-md-offset-2 col-md-10');
                break;

            default:
                break;
        }
        rec.show();
        if (isInternational()) {
            $.each($(priceNumber), function() {
                // intlConvertLogic($(this));
            });
        }
        if ($('.modal-add-to-bag').length > 0) {
          if ($('.modal-right #add-to-bag-list-contain ul li').length < 3) {
            $('.atb-arrow-wrapper').hide();
          }
        }
        if ($('.modal-add-to-registry').length > 0) {
          if ($('.modal-right #add-to-registry-list-contain ul li').length < 3) {
            $('.atb-arrow-wrapper').hide();
          }
        }
    }
    if (pageType !== 'ACMZ1') pageSetup();
}

const slickRecs = (li, recList) => {
    horzRecSlick(li, recList);
    // desktopTabletVerticalRecs(li, recList);
}

const slickRecsATB = (li, recList) => {
    if ($('.mobilePage').length > 0) {
      horzRecSlick(li, recList);
    } else {
      vertAddToBagRecSlick(li, recList);
      // allDevicesProductImage();

    }
    // desktopTabletVerticalRecs(li, recList);
    if ($('.modal-add-to-bag .rec-list .slick-list').length == 0) {
      // $('.modal-right').remove();
      // $('.modal-dialog').css('width', '400px');
      // $('.modal-left').css('width', '100%');
    }
}

// Add to Cart Modal (Horizontal Recs)
const ACMZ1_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('#add-to-bag-rec .rec-head'),
        recList = $('#add-to-bag-list-contain .rec-list'),
        rec = $('#add-to-bag-rec'),
        priceNumber = '#add-to-bag-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'ACMZ1');
    $(".rec-list img.lazy-img").lazyload({
        threshold: 100000
    });
};

//Add to Registry Modal (Horizontal Recs)
const ARMZ1_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('#add-to-registry-rec .rec-head'),
        recList = $('#add-to-registry-list-contain .rec-list'),
        rec = $('#add-to-registry-rec'),
        priceNumber = '#add-to-registry-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'ARMZ1');
    $(".rec-list img.lazy-img").lazyload({
        threshold: 100000
    });
};

// Just For You (Horizontal Recs)
const JFYZ1_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('.homepage-rec-results #horz-rec .rec-head'),
        recList = $('#homepage-rec-list-contain .rec-list'),
        rec = $('.homepage-rec-results #horz-rec'),
        priceNumber = '#homepage-rec-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'JFYZ1');
    $(".rec-list img.lazy-img").lazyload({
        threshold: 100000
    });
    slickRecs($('.homepage-rec-results #horz-rec .rec-list li'), $('.homepage-rec-results #horz-rec .rec-list'));
};

// Product Display Page (Vertical Recs)
const PDPZ1_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('#vert-rec .rec-head'),
        recList = $('#rec-list-contain .rec-list'),
        rec = $('#vert-rec'),
        priceNumber = '#rec-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'PDPZ1');
    $(".rec-list img.lazy-img").lazyload({
        threshold: 100000
    });
};

// Product Display Page (Horizontal Recs)
const PDPZ2_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('.recently-viewed-results #horz-rec .rec-head'),
        recList = $('#recent-list-contain .rec-list'),
        rec = $('.recently-viewed-results #horz-rec'),
        priceNumber = '#recent-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'PDPZ2');
    $(".rec-list img.lazy-img").lazyload({
        threshold: 10000
    });
    if ($('.desktopPage').length > 0) slickRecs($('.recently-viewed-results #horz-rec .rec-list li'), $('.recently-viewed-results #horz-rec .rec-list'));
};

// Product Display Page (Vertical Recs)
const PDPZ3_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('#vert-rec .rec-head'),
        recList = $('#rec-list-contain .rec-list'),
        rec = $('#vert-rec'),
        priceNumber = '#rec-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'PDPZ3');
    $(".rec-list img.lazy-img").lazyload({
        threshold: 100
    });
};

// Shopping Cart Page (Vertical Recs)
const SCPZ1_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
	if ($("div.recently-removed-results").length > 0) {
		cartHorizontalRecs(rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids);
	} else {
		var recHead = $('#vert-rec .rec-head'),
        recList = $('#rec-list-contain .rec-list'),
        rec = $('#vert-rec'),
        priceNumber = '#rec-list-contain .rec-list .price-number';
		buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'SCPZ1');
        lazyloadObserver()
	}
};

// Search Results Pages (Horizontal Recs)
const SRPZ1_zp = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('#horz-rec .rec-head'),
        recList = $('.rec-list'),
        rec = $('#horz-rec'),
        priceNumber = '#search-result-rec-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, 'SRPZ1');
    $("img.lazy-img").lazyload({
        threshold: 10000
    });
    if ($('.desktopPage').length > 0) slickRecs($('#horz-rec .rec-list li'), $('#horz-rec .rec-list'));
};

//Product Display Page (Horizontal Recs)
const recentlyViewed = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    var recHead = $('.recently-viewed-results #horz-rec .rec-head'),
        recList = $('#recent-list-contain .rec-list'),
        rec = $('.recently-viewed-results #horz-rec'),
        priceNumber = '#recent-list-contain .rec-list .price-number';
    buildRecs(zone, rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, zone);
    $("img.lazy-img").lazyload({
        threshold: 10000
    });
    if ($('.desktopPage').length > 0) slickRecs($('.recently-viewed-results #horz-rec .rec-list li'), $('.recently-viewed-results #horz-rec .rec-list'));
};

//Shopping Cart Page (Horizontal Recs)
const cartHorizontalRecs = (rec_product_ids, zone, symbolic, target_id, target_category, rec_attributes, target_attributes, target_header_txt, ab_test_id, rec_category_ids) => {
    if (typeof productListRemovals !== 'undefined') {
        var recHead = $('.recently-removed-results #horz-rec .rec-head'),
        recList = $('#removed-list-contain .rec-list'),
        rec = $('.recently-removed-results #horz-rec'),
        priceNumber = '#removed-list-contain .rec-list .price-number';
    buildRecs("SCPZ2", rec_attributes, recHead, target_header_txt, recList, rec, priceNumber, "SCPZ2");
    $("img.lazy-img").lazyload({
        threshold: 10000
    });
    if ($('.desktopPage').length > 0) slickRecs($('.recently-removed-results #horz-rec .rec-list li'), $('.recently-removed-results #horz-rec .rec-list'));
    }
};



var productRecs = {
    ACMZ1_zp: ACMZ1_zp,
    ARMZ1_zp: ARMZ1_zp,
    JFYZ1_zp: JFYZ1_zp,
    PDPZ1_zp: PDPZ1_zp,
    PDPZ2_zp: PDPZ2_zp,
    PDPZ3_zp: PDPZ3_zp,
    SCPZ1_zp: SCPZ1_zp,
    SCPZ2_zp: cartHorizontalRecs,
    SRPZ1_zp: SRPZ1_zp,
    recentlyViewed : recentlyViewed
}

export {
    slickRecs,
    productRecs,
    slickRecsATB
}
